import React, { useRef, useState, useEffect } from "react";
import { Tooltip } from "antd";
import { userEscapeString } from "@/utils/chat/index";

interface EllipsisTooltipProps {
  title: string;
  className?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

const EllipsisTooltip: React.FC<EllipsisTooltipProps> = ({ title, className, children, ...rest }) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isOverflow, setIsOverflow] = useState(false);

  const decodeHtml = (html: any) => {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = html;
    return tempElement.textContent;
  };

  // 处理流程：转义 -> 解码为普通文本 -> 截取 -> 重新转义
  const escapedTitle = userEscapeString(title);
  const plainText = decodeHtml(escapedTitle) || ""; // 先解码为普通文本
  const truncatedText = plainText.slice(0, 4); // 截取前4个字符
  const reEscapedText = userEscapeString(truncatedText); // 重新转义

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      // setIsOverflow(el.scrollWidth > el.clientWidth);
      setIsOverflow((title.length || 0) > 4);
    }
  }, [title, children]);

  return (
    <Tooltip title={isOverflow ? <span dangerouslySetInnerHTML={{ __html: userEscapeString(title) }} /> : ""} {...rest}>
      <span
        ref={textRef}
        className={className}
        style={{ whiteSpace: "nowrap", overflow: "hidden", display: "inline-block" }}
        dangerouslySetInnerHTML={{ __html: reEscapedText}}
      />
    </Tooltip>
  );
};

export default EllipsisTooltip;